export default __webpack_public_path__ + "static/media/logo.fdd8f5f0.svg";